import { createContext, useContext } from "react";

import type { RealtimeStatus } from "@/shared/realtime/connection";

export const RealtimeStatusContext = createContext<RealtimeStatus>("idle");

/**
 * The live connection's state: "live" while changes arrive as they happen, "connecting" or
 * "offline" while they do not (then screens fall back to polling), "idle" when signed out.
 */
export function useRealtimeStatus(): RealtimeStatus {
  return useContext(RealtimeStatusContext);
}

/** Whether changes are arriving live, so polling can rest. */
export function useIsLive(): boolean {
  return useRealtimeStatus() === "live";
}
